var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36875 8.44375L9.6375 10.9312M9.63125 4.06875L5.36875 6.55625M13.125 3.125C13.125 4.16053 12.2855 5 11.25 5C10.2145 5 9.375 4.16053 9.375 3.125C9.375 2.08947 10.2145 1.25 11.25 1.25C12.2855 1.25 13.125 2.08947 13.125 3.125ZM5.625 7.5C5.625 8.53553 4.78553 9.375 3.75 9.375C2.71447 9.375 1.875 8.53553 1.875 7.5C1.875 6.46447 2.71447 5.625 3.75 5.625C4.78553 5.625 5.625 6.46447 5.625 7.5ZM13.125 11.875C13.125 12.9105 12.2855 13.75 11.25 13.75C10.2145 13.75 9.375 12.9105 9.375 11.875C9.375 10.8395 10.2145 10 11.25 10C12.2855 10 13.125 10.8395 13.125 11.875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.9b343bd8cbf6d7482f1531bf213b9f69.svg";
export { ForwardRef as ReactComponent };